/** @jsxImportSource @emotion/react */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './i18n'; // Import i18n configuration

// 导入页面组件

import CodeReaderPrivacyPolicyEn from './pages/codereader/en/CodeReaderPrivacyPolicyEn';
import CodeReaderPrivacyPolicyJa from './pages/codereader/ja/CodeReaderPrivacyPolicyJa';
import CodeReaderPrivacyPolicyZhCn from './pages/codereader/zh-cn/CodeReaderPrivacyPolicyZhCn';
import CodeReaderPrivacyPolicyKo from './pages/codereader/ko/CodeReaderPrivacyPolicyKo';
import CodeReaderPrivacyPolicyZhTw from './pages/codereader/zh-tw/CodeReaderPrivacyPolicyZhTw';

import IdPhotoPrivacyPolicyEn from './pages/idphoto/en/IdPhotoPrivacyPolicyEn';
import IdPhotoPrivacyPolicyJa from './pages/idphoto/ja/IdPhotoPrivacyPolicyJa';
import IdPhotoPrivacyPolicyZhCn from './pages/idphoto/zh-cn/IdPhotoPrivacyPolicyZhCn';
import IdPhotoPrivacyPolicyKo from './pages/idphoto/ko/IdPhotoPrivacyPolicyKo';
import IdPhotoPrivacyPolicyZhTw from './pages/idphoto/zh-tw/IdPhotoPrivacyPolicyZhTw';

import CleanTextAiPrivacyPolicyEn from './pages/cleantextai/en/CleanTextAiPrivacyPolicyEn';
import CleanTextAiPrivacyPolicyJa from './pages/cleantextai/ja/CleanTextAiPrivacyPolicyJa';
import CleanTextAiPrivacyPolicyZhCn from './pages/cleantextai/zh-cn/CleanTextAiPrivacyPolicyZhCn';
import CleanTextAiPrivacyPolicyKo from './pages/cleantextai/ko/CleanTextAiPrivacyPolicyKo';
import CleanTextAiPrivacyPolicyZhTw from './pages/cleantextai/zh-tw/CleanTextAiPrivacyPolicyZhTw';

import CleanTextAiTermsOfServiceEn from './pages/cleantextai/en/CleanTextAiTermsOfServiceEn';
import CleanTextAiTermsOfServiceJa from './pages/cleantextai/ja/CleanTextAiTermsOfServiceJa';
import CleanTextAiTermsOfServiceZhCn from './pages/cleantextai/zh-cn/CleanTextAiTermsOfServiceZhCn';
import CleanTextAiTermsOfServiceKo from './pages/cleantextai/ko/CleanTextAiTermsOfServiceKo';
import CleanTextAiTermsOfServiceZhTw from './pages/cleantextai/zh-tw/CleanTextAiTermsOfServiceZhTw';

import ImgConvertPrivacyPolicyEn from './pages/imgconvert/en/ImgConvertPrivacyPolicyEn';
import ImgConvertPrivacyPolicyJa from './pages/imgconvert/ja/ImgConvertPrivacyPolicyJa';
import ImgConvertPrivacyPolicyZhCn from './pages/imgconvert/zh-cn/ImgConvertPrivacyPolicyZhCn';
import ImgConvertPrivacyPolicyKo from './pages/imgconvert/ko/ImgConvertPrivacyPolicyKo';
import ImgConvertPrivacyPolicyZhTw from './pages/imgconvert/zh-tw/ImgConvertPrivacyPolicyZhTw';

import Home from './pages/Home';

// ... (Rest of imports if any)

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Code Reader Privacy Policy Routes */}
          <Route path="/codereader/privacypolicy/en" element={<CodeReaderPrivacyPolicyEn />} />
          <Route path="/codereader/privacypolicy/ja" element={<CodeReaderPrivacyPolicyJa />} />
          <Route path="/codereader/privacypolicy/zh-cn" element={<CodeReaderPrivacyPolicyZhCn />} />
          <Route path="/codereader/privacypolicy/ko" element={<CodeReaderPrivacyPolicyKo />} />
          <Route path="/codereader/privacypolicy/zh-tw" element={<CodeReaderPrivacyPolicyZhTw />} />

          {/* ID Photo Privacy Policy Routes */}
          <Route path="/idphoto/privacypolicy/en" element={<IdPhotoPrivacyPolicyEn />} />
          <Route path="/idphoto/privacypolicy/ja" element={<IdPhotoPrivacyPolicyJa />} />
          <Route path="/idphoto/privacypolicy/zh-cn" element={<IdPhotoPrivacyPolicyZhCn />} />
          <Route path="/idphoto/privacypolicy/ko" element={<IdPhotoPrivacyPolicyKo />} />
          <Route path="/idphoto/privacypolicy/zh-tw" element={<IdPhotoPrivacyPolicyZhTw />} />

          {/* CleanTextAI Privacy Policy Routes */}
          <Route path="/cleantextai/privacypolicy/en" element={<CleanTextAiPrivacyPolicyEn />} />
          <Route path="/cleantextai/privacypolicy/ja" element={<CleanTextAiPrivacyPolicyJa />} />
          <Route path="/cleantextai/privacypolicy/zh-cn" element={<CleanTextAiPrivacyPolicyZhCn />} />
          <Route path="/cleantextai/privacypolicy/ko" element={<CleanTextAiPrivacyPolicyKo />} />
          <Route path="/cleantextai/privacypolicy/zh-tw" element={<CleanTextAiPrivacyPolicyZhTw />} />

          {/* CleanTextAI Terms of Service Routes */}
          <Route path="/cleantextai/termsofservice/en" element={<CleanTextAiTermsOfServiceEn />} />
          <Route path="/cleantextai/termsofservice/ja" element={<CleanTextAiTermsOfServiceJa />} />
          <Route path="/cleantextai/termsofservice/zh-cn" element={<CleanTextAiTermsOfServiceZhCn />} />
          <Route path="/cleantextai/termsofservice/ko" element={<CleanTextAiTermsOfServiceKo />} />
          <Route path="/cleantextai/termsofservice/zh-tw" element={<CleanTextAiTermsOfServiceZhTw />} />

          {/* ImgConvert Privacy Policy Routes */}
          <Route path="/imgconvert/privacypolicy/en" element={<ImgConvertPrivacyPolicyEn />} />
          <Route path="/imgconvert/privacypolicy/ja" element={<ImgConvertPrivacyPolicyJa />} />
          <Route path="/imgconvert/privacypolicy/zh-cn" element={<ImgConvertPrivacyPolicyZhCn />} />
          <Route path="/imgconvert/privacypolicy/ko" element={<ImgConvertPrivacyPolicyKo />} />
          <Route path="/imgconvert/privacypolicy/zh-tw" element={<ImgConvertPrivacyPolicyZhTw />} />

          {/* Root Route */}
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
